import { render, staticRenderFns } from "./TriptychsSlide.vue?vue&type=template&id=1358c7ff&scoped=true&"
import script from "./TriptychsSlide.vue?vue&type=script&lang=js&"
export * from "./TriptychsSlide.vue?vue&type=script&lang=js&"
import style0 from "./TriptychsSlide.vue?vue&type=style&index=0&id=1358c7ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358c7ff",
  null
  
)

export default component.exports